// import React, { useState } from "react";
// import Select from "react-select";
// import InputMask from "react-input-mask";

// const TimePicker = ({ onChange }) => {
//   const [inputValue, setInputValue] = useState("");
//   const [customOptions, setCustomOptions] = useState([]);

//   // Predefined time options with values in minutes
//   const predefinedOptions = [
//     { value: 15, label: "15 min" },
//     { value: 30, label: "30 min" },
//     { value: 45, label: "45 min" },
//     { value: 60, label: "1:00 hour" },
//     { value: 90, label: "1:30 hours" },
//     { value: 360, label: "6:00 hours" },
//     { value: 420, label: "7:00 hours" },
//     { value: 480, label: "8:00 hours" },
//     { value: 540, label: "9:00 hours" },
//     { value: 600, label: "10:00 hours" },
//   ];

//   // Convert HH:MM format to minutes
//   const convertToMinutes = (time) => {
//     const [hours, minutes] = time.split(":").map(Number);
//     return hours * 60 + minutes;
//   };

//   const handleSelectChange = (selectedOption) => {
//     setInputValue(selectedOption.label); // Display label in input
//     if (onChange) onChange(selectedOption.value); // Send minutes to backend
//   };

//   const handleInputChange = (e) => {
//     setInputValue(e.target.value);
//   };

//   const handleBlur = () => {
//     if (!inputValue) return;

//     // Validate format H:MM
//     const timePattern = /^[0-9]:[0-5][0-9]$/;
//     if (!timePattern.test(inputValue)) {
//       alert("Invalid time format. Enter H:MM (e.g., 1:30)");
//       return;
//     }

//     const minutes = convertToMinutes(inputValue);

//     if (!predefinedOptions.some((opt) => opt.value === minutes)) {
//       setCustomOptions([...customOptions, { value: minutes, label: inputValue }]);
//     }

//     if (onChange) onChange(minutes); // Send minutes to backend
//   };

//   return (
//     <div style={{ width: "250px" }}>
//       {/* Manual Input */}
//       <InputMask
//         mask="99:99"
//         maskChar={null}
//         value={inputValue}
//         onChange={handleInputChange}
//         onBlur={handleBlur}
//         placeholder="Enter time (e.g., 1:30)"
//         className="time-input"
//         style={{
//           width: "100%",
//           padding: "8px",
//           border: "1px solid #ccc",
//           borderRadius: "4px",
//           fontSize: "16px",
//           marginBottom: "8px",
//         }}
//       />

//       {/* Dropdown Selection */}
//       <Select
//         options={[...predefinedOptions, ...customOptions]}
//         onChange={handleSelectChange}
//         placeholder="Select time"
//         isSearchable={false}
//       />
//     </div>
//   );
// };

// export default TimePicker;

import React, { useState, useRef , useEffect} from "react";
import InputMask from "react-input-mask";

const TimePicker = ({ onChange, selectedTime }) => {
  const [inputValue, setInputValue] = useState("");
  const [showDropdown, setShowDropdown] = useState(false);
  const inputRef = useRef(null);

  // Predefined time options (values in minutes)
  const predefinedOptions = [
    { value: 15, label: "15 min" },
    { value: 30, label: "30 min" },
    { value: 45, label: "45 min" },
    { value: 60, label: "1:00 hour" },
    { value: 90, label: "1:30 hours" },
    { value: 120, label: "2:00 hours" },
    { value: 180, label: "3:00 hours" },
    { value: 240, label: "4:00 hours" },
  ];

  // Convert total minutes to HH:mm format
  const convertToHHMM = (totalMinutes) => {
    const hours = Math.floor(totalMinutes / 60);
    const minutes = totalMinutes % 60;
    return `${String(hours).padStart(2, "0")}:${String(minutes).padStart(
      2,
      "0"
    )}`;
  };

  const handleSelect = (option) => {
    const formattedTime = convertToHHMM(option.value); // Convert to HH:mm format
    setInputValue(formattedTime); // Set formatted time in input
    setShowDropdown(false); // Hide dropdown
    if (onChange) onChange(option.value); // Send minutes to backend
  };

  // Convert selectedTime (HH:mm:ss) to HH:mm for display
  useEffect(() => {
    if (selectedTime) {
      const [hours, minutes] = selectedTime.split(":").map(Number);
      setInputValue(
        `${String(hours).padStart(2, "0")}:${String(minutes).padStart(2, "0")}`
      );
    }
  }, [selectedTime]);

  const handleInputChange = (e) => {
    setInputValue(e.target.value);
  };

  const handleBlur = () => {
    setTimeout(() => setShowDropdown(false), 200); // Delay hiding for click selection
  };

  const handleFocus = () => {
    setShowDropdown(true);
  };

  const handleKeyDown = (e) => {
    if (e.key === "Enter") {
      setShowDropdown(false);
      if (/^([01]?[0-9]|2[0-3]):[0-5][0-9]$/.test(inputValue)) {
        const minutes = convertToMinutes(inputValue);
        if (onChange) onChange(minutes);
      } else {
        alert("Invalid format. Enter HH:mm (e.g., 01:30)");
      }
    }
  };

  // Convert HH:MM to total minutes
  const convertToMinutes = (time) => {
    const [hours, minutes] = time.split(":").map(Number);
    return hours * 60 + minutes;
  };

  return (
    <div style={{ position: "relative" }}>
      {/* Input field */}
      <InputMask
        mask="99:99"
        maskChar={null}
        value={inputValue}
        onChange={handleInputChange}
        onFocus={handleFocus}
        onBlur={handleBlur}
        onKeyDown={handleKeyDown}
        ref={inputRef}
        placeholder="Select or enter time (HH:MM)"
        className="time-input"
        style={{ width: "100%" }}
      />

      {/* Dropdown suggestions */}
      {showDropdown && (
        <ul
          style={{
            position: "absolute",
            top: "100%",
            left: 0,
            width: "100%",
            background: "white",
            border: "1px solid #d8dae5",
            borderRadius: "0.375rem",
            marginTop: "4px",
            padding: "0.5rem 0",
            listStyle: "none",
            boxShadow: "0 0.5rem 1rem rgba(0, 0, 0, 0.15)",
            zIndex: 1000,
            maxHeight: "150px",
            overflowY: "auto",
          }}
        >
          {predefinedOptions.map((option) => (
            <li
              key={option.value}
              onMouseDown={() => handleSelect(option)}
              style={{
                padding: "0.5rem 1rem",
                cursor: "pointer",
                fontSize: "12px",
              }}
            >
              {option.label}
            </li>
          ))}
        </ul>
      )}
    </div>
  );
};

export default TimePicker;
